module.exports = __webpack_public_path__ + "static/media/infoJumbo3.2f8a86d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fetzer/images/infoJumbo3.png
// module id = 492
// module chunks = 0